__turbopack_context__.v({
  "button": "Explanation-module-scss-module__cbCcSa__button",
  "explanationCloseBtn": "Explanation-module-scss-module__cbCcSa__explanationCloseBtn",
  "lightThemeCloseButton": "Explanation-module-scss-module__cbCcSa__lightThemeCloseButton",
  "popoverContainer": "Explanation-module-scss-module__cbCcSa__popoverContainer",
  "popoverContent": "Explanation-module-scss-module__cbCcSa__popoverContent",
});
